import { convertDateFromStateToISO } from '@che-ins-ui/datepicker';
export const transformInsurerNames = (insurer) => {
    const { firstName, lastName, birthday } = insurer;
    return {
        lastName,
        firstName,
        birthday,
    };
};
export const transformInsurerForApi = (insurer) => {
    const { firstName, lastName, birthday } = insurer;
    return {
        lastName,
        firstName,
        birthday: convertDateFromStateToISO(birthday),
    };
};
export function containsLatin(str) {
    const latinPattern = /[A-Za-z]/;
    return latinPattern.test(str);
}
export const formatNameOnBlur = (value) => value?.trim().split(' ').filter(Boolean).join(' ');
